<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-one
      banner_height="page-banner-height-2"
      :banner="content.about_banner_image_url || ''"
      :title="content.about_banner_title || 'About Us'"
      :subtitle="content.about_banner_subtitle || 'About Us'"
    ></breadcrumb-one>
    <!-- breadcrumb end -->

    <div
      class="about-area pt-80 pb-80"
      style="background-image:url(/images/bg/about-bg.png);"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6">
            <div class="about-content">
              <span>{{ content.about_tagline || 'ABOUT OUR ONLINE STORE' }}</span>
              <h4>{{ content.about_small_heading || 'Hello,' }}</h4>
              <h5 class="banner-t mb-30">
                {{ content.about_main_heading || 'With 25+ Years Of Experience' }}
              </h5>
              <p class="about-text" v-if="content.about_short_desc">
                {{ content.about_short_desc }}
              </p>
              <p v-if="content.about_long_desc">
                {{ content.about_long_desc }}
              </p>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6">
            <div class="about-image w-img">
              <img
                :src="content.about_image_url || '/images/about/about-b.png'"
                alt="About"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbOne from '@/components/breadcrumb/breadcrumb-one.vue'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "About",
  components: {
    BreadcrumbOne,
  },
  data() {
    return {
      content: {},
    }
  },
  mounted() {
    this.fetchContent()
  },
  methods: {
    async fetchContent() {
      try {
        const { data } = await this.$axios.get('/cms/about')
        this.content = data || {}
      } catch (err) {
        console.error('Failed to load about page content:', err)
      }
    },
  },
};
</script>

<style scoped>
/* Add styles for Home page */
</style>